import React from 'react';

import styles from './SingleValueCard.module.scss';
import StatisticsCard from '../../../../Shared/StatisticsCard/StatisticsCard';

function SingleValueCard(props: SingleValueCardProps) {
    return (
        <StatisticsCard
            title={props.title}
        >
            <div className={styles.cardcontent}>
                { props.data != undefined ?
                    <div>
                        <hr/>
                        <p>{props.data}</p>
                    </div>
                : null }
            </div>
        </StatisticsCard>
    );
}

class SingleValueCardProps {
    title!: string;
    data!: any;
}

export default SingleValueCard;